import { api } from '../../lib/api'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGIN_CHECK_SUCCESS = 'LOGIN_CHECK_SUCCESS'
export const LOGIN_CHECK_FAILED = 'LOGIN_CHECK_FAILED'


export function login(email, password) {
  return function (dispatch) {
    dispatch({
      type: LOGIN_REQUEST,
      email,
      password,
    });

    return api.login(email, password).then((loginResponse) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: loginResponse
      })
    }).catch((error) => {
      dispatch({
        type: LOGIN_FAILED,
        error
      })
    })
  }
}

export function checkLoginSuccess(response) {
  return {
    type: LOGIN_CHECK_SUCCESS,
    payload: response
  };
}

export function checkLoginFailed(error) {
  return {
    type: LOGIN_CHECK_FAILED,
    error
  };
}

export const checkLogin = () => dispatch => api.checkLogin().then((response) => {
  dispatch(checkLoginSuccess(response));
}).catch((error) => {
  dispatch(checkLoginFailed(error));
  throw new Error(error);
});



// WEBPACK FOOTER //
// ./src/redux/actions/loginActions.js